import {
  useQuery,
  gql
} from '@apollo/client';

interface SiteInfo {
  version: string;
  activeUsersInLastWeek: number;
}

const GET_SITE_INFO = gql`
  query SiteInfo {
    version
    activeUsersInLastWeek
  }
`;

function Info() {
  let { data: siteInfo, loading, error } = useQuery(GET_SITE_INFO, {
    fetchPolicy: 'network-only', // Always fetch fresh data
  });


  if (loading) {
    return (
      <div className="p-6 max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">Site Information</h1>
        <div className="animate-pulse">
          loading...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-6 max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">Site Information</h1>
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
          Error loading site information. Please try again later.
        </div>
      </div>
    );
  }

  return siteInfo ? (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">Site Information</h1>
      <div className="bg-white shadow-md rounded-lg" >
        <div className="p-6">
          <h2 className="text-xl font-semibold text-gray-700 mb-4">Version</h2>
          <p className="text-gray-600 mb-4">{siteInfo.version}</p>
          <h2 className="text-xl font-semibold text-gray-700 mb-4">Active Users in Last Week</h2>
          <p className="text-gray-600">{siteInfo.activeUsersInLastWeek}</p>
        </div>
      </div>
    </div>
  ) : (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">Site Information</h1>
      <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
        No site information available.
      </div>
    </div>
  );
};

export { Info };
